import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-question-complete-modal',
  templateUrl: './question-complete-modal.component.html',
  styleUrls: ['./question-complete-modal.component.scss']
})
export class QuestionCompleteModalComponent implements OnInit {

  questionParams = {
    sdg: '',
    country: '',
    subject: '',
    difficulty: ''
  };
  questionStatus: any;

  constructor(public dialogRef: MatDialogRef<QuestionCompleteModalComponent>,
    public router: Router, public serviceData: DataService, public loaderService: LoaderService,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    this.getQuestionStatus();
  }
  playNextTopic() {
    this.dialogRef.close("next")
  }
  goToHome() {
    this.dialogRef.close()
  }
  close() {
    this.dialogRef.close()
  }

  getQuestionStatus() {
    this.loaderService.display(true);
    this.serviceData.getQuestionStatus(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data);
        this.questionStatus = resp.data;
      }
      this.loaderService.display(false);
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

}
